__turbopack_context__.v({
  "advantages": "mkbq6a_advantages",
  "container": "mkbq6a_container",
  "documents": "mkbq6a_documents",
  "header": "mkbq6a_header",
  "headerButton": "mkbq6a_headerButton",
  "headerButtons": "mkbq6a_headerButtons",
  "helpForm": "mkbq6a_helpForm",
  "pageTitle": "mkbq6a_pageTitle",
  "recomendedSliderWrapper": "mkbq6a_recomendedSliderWrapper",
  "services": "mkbq6a_services",
  "team": "mkbq6a_team",
  "title": "mkbq6a_title",
});
